define( [
	"../../core"
], function( jQuery ) {
	return jQuery.now();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/nonce.js
// module id = 250
// module chunks = 0